/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 16:54:04 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { ReferenceInput, SelectInput, Filter, useTranslate } from 'react-admin';
import { employmentStatusOptions } from 'utils/choices';
import { tabbedFilters } from 'styles';

const ContractFilters = ({ organisationFilter, organisationId, ...props }) => {
  const translate = useTranslate();
  const classes = tabbedFilters();

  return (
    <Filter {...props}>
      <ReferenceInput
        label="resources.Organisation.fields.organisation"
        source="subcontractorId"
        className={classes.filterFields}
        reference="Organisation"
        emptyText={translate('resources.Contract.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        fullWidth={true}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label="resources.Employment.fields.project"
        source="projectId"
        className={classes.filterFields}
        reference="Project"
        filter={{ subcontractorId: organisationId }}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput
          source="id"
          optionText="name"
          disabled={organisationId ? false : true}
        />
      </ReferenceInput>
      <SelectInput
        source="status"
        choices={employmentStatusOptions}
        className={classes.filterFields}
        label="resources.Employment.fields.status"
      />
    </Filter>
  );
};

export default ContractFilters;
